(function () {
  Flint.file('mframework/views/picChooser.js', function (require) {
    Flint.staticStyles('PicChooser', {
      '$': '#_flintapp .ViewPicChooser',
      '$fbLoading': '#_flintapp fbLoading.PicChooser, #_flintapp .PicChooser.fbLoading, #_flintapp .ViewPicChooser.fbLoading, #_flintapp .PicChooser > .fbLoading',
      '$Loader': '#_flintapp .ViewPicChooser .ViewLoader',
      '$fromUpload': '#_flintapp fromUpload.PicChooser, #_flintapp .PicChooser.fromUpload, #_flintapp .ViewPicChooser.fromUpload, #_flintapp .PicChooser > .fromUpload',
      '$orSection': '#_flintapp orSection.PicChooser, #_flintapp .PicChooser.orSection, #_flintapp .ViewPicChooser.orSection, #_flintapp .PicChooser > .orSection',
      '$fromFacebook': '#_flintapp fromFacebook.PicChooser, #_flintapp .PicChooser.fromFacebook, #_flintapp .ViewPicChooser.fromFacebook, #_flintapp .PicChooser > .fromFacebook',
      '$deviceIcon': '#_flintapp deviceIcon.PicChooser, #_flintapp .PicChooser.deviceIcon, #_flintapp .ViewPicChooser.deviceIcon, #_flintapp .PicChooser > .deviceIcon',
      '$fbIcon': '#_flintapp fbIcon.PicChooser, #_flintapp .PicChooser.fbIcon, #_flintapp .ViewPicChooser.fbIcon, #_flintapp .PicChooser > .fbIcon'
    }, {
      '$': {
        flexDirection: 'row'
      },
      '$fbLoading': {
        border: '1px dashed #ccc',
        alignItems: 'center',
        justifyContent: 'center'
      },
      '$Loader': {
        marginTop: 20
      },
      '$fromUpload': {
        alignItems: 'center',
        position: 'relative',
        top: -6,
        color: '#999',
        fontSize: 12
      },
      '$orSection': {
        marginLeft: 20,
        marginRight: 20,
        alignSelf: 'center',
        color: '#999'
      },
      '$fromFacebook': {
        alignItems: 'center',
        position: 'relative',
        top: 4,
        color: '#999',
        fontSize: 12
      },
      '$deviceIcon': {
        opacity: 0.7
      },
      '$fbIcon': {
        width: 40,
        height: 40,
        opacity: 0.8,
        marginBottom: 16
      }
    });
    Flint.view('PicChooser', function (view, on, $) {
      var context = initContext(view, {
        isMobile: atom()
      });

      var pro = initPro(view, {
        initialPicKey: M.defaultAtom(null),
        editable: M.defaultAtom(true),
        circle: M.defaultAtom(false),
        width: M.defaultAtom(300),
        height: M.defaultAtom(300),
        allowUpload: M.defaultAtom(true),
        allowFacebook: M.defaultAtom(false),
        picStyle: M.mapAtom({}),
        noPicStyle: M.mapAtom({}),
        zoomable: M.defaultAtom(false)
      });

      var noPicStyle = derivation(function () {
        return IMap({
          width: pro.width.get(),
          height: pro.height.get(),
          alignItems: 'center',
          justifyContent: 'center',
          background: 'white',
          border: '1px dashed #ccc',
          borderRadius: pro.circle.get() ? '50%' : 8
        }).merge(pro.noPicStyle.get());
      });

      var picKey = atom(pro.initialPicKey.get());
      var pendingFbPhoto = atom(null);

      picKey.react(function (picKey) {
        if (view.props.onSelect) {
          view.props.onSelect({ picKey: picKey });
        }
      }, { skipFirst: true });

      var selectFbPhoto = function selectFbPhoto(photo) {
        pendingFbPhoto.set(photo);

        var biggestImage = null;
        photo.images.forEach(function (image) {
          if (!biggestImage || image.width > biggestImage.width) {
            biggestImage = image;
          }
        });

        M.apiPost('transloadPic', {
          params: {
            url: biggestImage.source
          }
        }).then(function (apiResponse) {
          pendingFbPhoto.set(null);
          picKey.set(apiResponse.picKey);
        }, function (err) {
          pendingFbPhoto.set(null);
          M.util.alertError(err);
        });
      };view.render(function () {
        return Flint.iff(pro.allowUpload.get()) && view.el(
          ['uploadSection', 1],
          { if: pro.allowUpload.get() },
          view.el(
            ['UploadPicChooser', 1],
            {
              initialPicKey: pro.initialPicKey.get(),
              editable: pro.editable.get(),
              width: pro.width.get(),
              height: pro.height.get(),
              zoomable: pro.zoomable.get(),
              circle: pro.circle.get(),
              picStyle: pro.picStyle.get(),
              noPicStyle: pro.noPicStyle.get(),
              onSelect: function (e) {
                return picKey.set(e.picKey);
              },
              onZoomIn: view.props.onZoomIn,
              onZoomOut: view.props.onZoomOut
            },
            view.el(
              ['fromUpload', 1],
              null,
              view.el(['img', 1], { className: 'deviceIcon',
                src: context.isMobile.get() ? "/images/device.png" : "/images/computerIconGray.png"
              }),
              context.isMobile.get() ? "upload a pic" : "upload a pic"
            )
          )
        );
      });view.render(function () {
        return Flint.iff(pro.allowUpload.get() && pro.allowFacebook.get()) && view.el(
          ['orSection', 1],
          { if: pro.allowUpload.get() && pro.allowFacebook.get() },
          'or'
        );
      });view.render(function () {
        return Flint.iff(pro.allowFacebook.get()) && view.el(
          ['facebookSection', 1],
          { if: pro.allowFacebook.get() },
          Flint.iff(!pendingFbPhoto.get()) && view.el(
            ['FacebookPhotoChooser', 1],
            {
              if: !pendingFbPhoto.get(),
              editable: pro.editable.get(),
              width: pro.width.get(),
              height: pro.height.get(),
              circle: pro.circle.get(),
              picStyle: pro.picStyle.get(),
              noPicStyle: pro.noPicStyle.get(),
              onSelect: function (_ref) {
                var photo = _ref.photo;
                return selectFbPhoto(photo);
              }
            },
            view.el(
              ['fromFacebook', 1],
              null,
              view.el(['img', 2], { className: 'fbIcon', src: '/images/facebookIconGray.png' }),
              'pic from Facebook'
            )
          ),
          Flint.iff(pendingFbPhoto.get()) && view.el(
            ['fbLoading', 1],
            { if: pendingFbPhoto.get(),
              style: noPicStyle.get().toJS()
            },
            view.el(['Loader', 1], null)
          )
        );
      });

      $["fbLoading"] = function (_, _index) {
        return {
          width: pro.width.get(),
          height: pro.height.get() };
      };

      '23ff41e5';

      $["deviceIcon"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? 50 : 80,
          height: context.isMobile.get() ? 50 : 80,
          marginBottom: context.isMobile.get() ? 10 : 0 };
      };
    });
  })
})();
//# sourceMappingURL=picChooser.js.map
